let $pwrestore = $('#pwdrestore-form');

let validator = $pwrestore.validate({
    rules: {
        email: {
            required: true,
            email: true
        },
    },
    highlight: function (element) {
        $(element).closest('.input-line').addClass('has-error');
    },
    unhighlight: function (element) {
        $(element).closest('.input-line').removeClass('has-error');
    },
    messages: {
        email: {
            required: "Поле обязательно для заполнения",
            email: "Некорректный email",
        },
    },
});

$pwrestore.on('submit', function(e) {

    if (validator.valid()) {
        e.preventDefault();
        oc.progressBar.show();
        oc.request(this, 'RestorePassword::onAjax', {
            success: function(response) {
                oc.progressBar.hide();
                if (!response) {
                    return;
                }

                var redirect = (response.$env && response.$env.getRedirectUrl()) || response['X_OCTOBER_REDIRECT']; // jshint ignore:line
                if (redirect) {
                    window.location = redirect;
                    return;
                }

                if (!response.status) {
                    oc.flashMsg({message: response.message, class: 'flash-message-error'});
                }
            }
        });
        return false;
    }

});
